// Contato manual (decisão de produto): cancelar e trocar de plano NÃO são
// self-service — abrimos o WhatsApp da Nexus Tech para atendimento humano.
// NENHUMA destas funções dispara cobrança/checkout: são só deep-links de
// conversa. Compartilhado entre a tela de gestão e a grade de planos para não
// duplicar número, codificação nem copy da marca.
export const WHATSAPP_NUMBER = "5551992747402";

// Mensagens na voz da Nexus (coloquial-BR, "a gente", acolhedora). Vão SEMPRE
// via encodeURIComponent — acentos e pontuação são codificados corretamente.
export const CANCEL_MESSAGE =
  "Oi, pessoal! Sou cliente da Nexus Tech e preciso cancelar minha assinatura. Podem me ajudar?";

export function changePlanMessage(planName) {
  return `Oi, pessoal! Sou cliente da Nexus Tech e quero trocar pro plano ${planName}. Como funciona?`;
}

export function whatsappUrl(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function openWhatsapp(message) {
  // noopener/noreferrer: nunca dar acesso ao window.opener da aba externa.
  window.open(whatsappUrl(message), "_blank", "noopener,noreferrer");
}
